export const APP_CARD = {
  "Card.Space.Around": {
    defaultValue: "default"
  },
  "Card.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Card.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Card.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Card.Space.Around.Left": {
    defaultValue: "2px"
  },
  "Card.Height.Type": {
    defaultValue: "fixed"
  },

  "Card.Bg.Color": {
    ref: "Color.White"
  },
  "Card.Hover.Bg.Color": {
    ref: "Color.White"
  },
  "Card.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Card.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Card.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Card.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Card.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Card.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Card.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Card.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Card.Margin.Top": {
    defaultValue: "0px"
  },
  "Card.Margin.Right": {
    defaultValue: "0px"
  },
  "Card.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Card.Margin.Left": {
    defaultValue: "0px"
  },
  "Card.Padding.Top": {
    defaultValue: "16px"
  },
  "Card.Padding.Right": {
    defaultValue: "16px"
  },
  "Card.Padding.Bottom": {
    defaultValue: "16px"
  },
  "Card.Padding.Left": {
    defaultValue: "16px"
  },
  "Card.Width": {
    defaultValue: "220px"
  },
  "Card.Height": {
    defaultValue: "auto"
  },
  "Card.Min.Height": {
    defaultValue: "unset"
  },
  "Card.Min.Width": {
    defaultValue: "0px"
  },
  "Card.Max.Height": {
    defaultValue: "unset"
  },
  "Card.Max.Width": {
    defaultValue: "unset"
  },
  "Card.Shadow.Type": {
    ref: "Shadow.100.Pos"
  },
  "Card.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Card.Border.Style": {
    defaultValue: "solid"
  },
  "Card.Border.Color": {
    ref: "Color.Transparent"
  },
  // Card's icon configs
  "Card.Icon.Color": {
    ref: "Color.Black"
  },
  "Card.Icon.Container.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Card.Icon.Container.Border.Style": {
    defaultValue: "solid"
  },
  "Card.Icon.Container.Border.Color": {
    ref: "Color.Transparent"
  },
  "Card.Icon.Container.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Card.Icon.Container.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Card.Icon.Container.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Card.Icon.Container.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Card.Icon.Container.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Card.Icon.Container.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Card.Icon.Container.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Card.Icon.Container.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Card.Icon.Container.Width": {
    defaultValue: "40px"
  },
  "Card.Icon.Container.Height": {
    defaultValue: "40px"
  },
  "Card.Icon.Container.Padding.Top": {
    defaultValue: "8px"
  },
  "Card.Icon.Container.Padding.Right": {
    defaultValue: "8px"
  },
  "Card.Icon.Container.Padding.Bottom": {
    defaultValue: "8px"
  },
  "Card.Icon.Container.Padding.Left": {
    defaultValue: "8px"
  },
  "Card.Icon.Container.Shadow.Type": {
    defaultValue: "none"
  },
  "Card.Icon.Container.Shadow.Color": {
    ref: "Color.Shadow"
  },
  // Card description configs
  "Card.Description.Font.Size": {
    ref: "Font.Size.13"
  },
  "Card.Description.Color": {
    ref: "Color.Gray.500"
  },
  "Card.Description.Font.Weight": {
    ref: "Font.Weight.Regular"
  },
  "Card.Description.Line.Height": {
    ref: "Line.Height.Smallplus"
  },
  "Card.Description.Letter.Spacing": {
    ref: "Letter.Spacing.Smallplus"
  },
  "Card.Description.Font.Style": {
    defaultValue: "normal"
  },
  "Card.Description.Text.Decoration": {
    defaultValue: "none"
  },
  // Card value / count configs
  "Card.Value.Font.Size": {
    ref: "Font.Size.24"
  },
  "Card.Value.Color": {
    ref: "Color.Black"
  },
  "Card.Value.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Card.Value.Line.Height": {
    ref: "Line.Height.H3"
  },
  "Card.Value.Letter.Spacing": {
    ref: "Letter.Spacing.H3"
  },
  "Card.Value.Font.Style": {
    defaultValue: "normal"
  },
  "Card.Value.Text.Decoration": {
    defaultValue: "none"
  },
  "Card.Cursor": {
    defaultValue: "pointer"
  },
  "Card.Hover.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Card.Hover.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Card.Hover.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Card.Hover.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Card.Hover.Border.Color": {
    ref: "Color.Transparent"
  },
  "Card.Hover.Shadow.Type": {
    ref: "Shadow.100.Pos"
  },
  "Card.Hover.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Card.Box.Sizing": {
    defaultValue: "border-box"
  }
};
